import React, { useState, useEffect } from "react";
import BodyWrapper from "../utils/BodyWrapper";
import { API } from "../App";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Link } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

function TribunalDeDisciplina() {
  const [disciplineContents, setDisciplineList] = useState([]);
  useEffect(() => {
    getDisciplines();
  }, []);

  function Row(props) {
    // Table style

    const subTableHeaderStyle = { color: "white" };
    const subTableRowStyle = { color: "white" };

    return (
      <Table className="tribunaldedisciplina__contentTable" size="small">
        <TableHead className="tribunaldedisciplina__contentTableHead">
          <TableRow className="tribunaldedisciplina__contentTableHeadRow">
            <TableCell style={subTableHeaderStyle}></TableCell>
            <TableCell style={subTableHeaderStyle}>
              <p className="tribunaldedisciplina__contentTableCell">Archivo</p>
            </TableCell>
            <TableCell style={subTableHeaderStyle}>
              <p className="tribunaldedisciplina__contentTableCell">Fecha</p>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody className="tribunaldedisciplina__contentTableBody">
          {props.post.contents
            ?.sort((a, b) => {
              if (a.createdAt > b.createdAt) return -1;
              if (a.createdAt < b.createdAt) return 1;
              return 0;
            })
            .map((content) => (
              <TableRow
                className="tribunaldedisciplina__contentTableBodyRow"
                key={content.id}
              >
                <TableCell
                  className="tribunaldedisciplina__contentTableBodyCell-fileFormat"
                  style={subTableRowStyle}
                >
                  <img
                    className="tribunaldedisciplina__contentTableFormatImage"
                    src={`/${content.extension}.png`}
                    srcSet={`/${content.extension}.png`}
                    alt={`/${content.extension}.png`}
                    loading="lazy"
                  />
                </TableCell>
                <TableCell style={subTableRowStyle}>
                  <Link href={`/content/${content.path}`} target="_blank">
                    <p className="tribunaldedisciplina__contentTableBodyCell">
                      {content.name}
                    </p>
                  </Link>
                </TableCell>
                <TableCell style={subTableRowStyle}>
                  <p className="tribunaldedisciplina__contentTableBodyCell">
                    {content.createdAt?.substring(0, 10)}
                  </p>
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    );
  }

  const getDisciplines = async () => {
    const disciplineResponse = await fetch(
      `${API}/tribunal-disciplina?page=0&limit=100`
    )
      .then((res) => (res.status === 200 ? res.json() : res.status))
      .catch((err) => console.log(err));
    if (disciplineResponse) {
      setDisciplineList(disciplineResponse);
    } else {
      return [];
    }
  };
  return (
    <>
      <BodyWrapper>
        <Link to="/" className="tribunaldedisciplina__backBtn">
          <ArrowBackIosNewIcon />
        </Link>
        <div className="tribunaldedisciplina">
          <h1 className="tribunaldedisciplina__title">
            Tribunal de Disciplina
          </h1>
          <article className="tribunaldedisciplina__posts">
            {disciplineContents.map((p) => (
              <div key={p.id} className="tribunaldedisciplina__post">
                <div className="tribunaldedisciplina__postHeader">
                  <img
                    className="tribunaldedisciplina__postHeaderImage"
                    src="/folder.png"
                    alt="file"
                  />
                  <div className="tribunaldedisciplina__postHeaderTitle">
                    <span>{p.name}</span>
                  </div>
                </div>
                <div className="tribunaldedisciplina__postContent">
                  <div className="tribunaldedisciplina__contentRow">
                    <Row post={p} />
                  </div>
                </div>
              </div>
            ))}
          </article>
        </div>
      </BodyWrapper>
    </>
  );
}

export default TribunalDeDisciplina;
